/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetRoleSecurityGroupRequest
 */
export interface SetRoleSecurityGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof SetRoleSecurityGroupRequest
     */
    securityGroupId?: string | null;
}

/**
 * Check if a given object implements the SetRoleSecurityGroupRequest interface.
 */
export function instanceOfSetRoleSecurityGroupRequest(value: object): value is SetRoleSecurityGroupRequest {
    return true;
}

export function SetRoleSecurityGroupRequestFromJSON(json: any): SetRoleSecurityGroupRequest {
    return SetRoleSecurityGroupRequestFromJSONTyped(json, false);
}

export function SetRoleSecurityGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetRoleSecurityGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'securityGroupId': json['securityGroupId'] === undefined ? undefined : json['securityGroupId'] === null ? null : json['securityGroupId'],
    };
}

export function SetRoleSecurityGroupRequestToJSON(json: any): SetRoleSecurityGroupRequest {
    return SetRoleSecurityGroupRequestToJSONTyped(json, false);
}

export function SetRoleSecurityGroupRequestToJSONTyped(value?: SetRoleSecurityGroupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'securityGroupId': value['securityGroupId'],
    };
}

